import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStoragesService {
  getItem(key: string) {
    let newkey = this.addClinicId(key);
    const item = localStorage.getItem(newkey);
    return (item) ? JSON.parse(item) : null;
  }

  setItem(key: string, value: any): void {
    let newkey = this.addClinicId(key);
    localStorage.setItem(newkey, JSON.stringify(value));
  }

  removeItem(key: string): void {
    let newkey = this.addClinicId(key);
    localStorage.removeItem(newkey);
  }

  clear() {
    localStorage.clear();
  }

  addClinicId(key: string){
    if (key == 'ConsoleInfo' || key == 'DebugMode'){
      // 這兩個跟著電腦，不用管是哪間院所Id
    } else{
      let nowclinicid = sessionStorage.getItem('ClinicId');
      if (nowclinicid) {
        return nowclinicid + "_" + key
      }
    }
    return key;
  }
}
